import BootstrapTable, { BootstrapTableProps } from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setCurrentPage, setTablePageSize } from '../../redux/actions';
import { ReactNode } from 'react';
import cronstrue from 'cronstrue';
import { fetchJobs, deleteJob } from '../../utils/api';
import { RootState } from '../../redux/store';
import { UserInfoType } from '../../types/AppTypes';
import { useSelector } from 'react-redux';

const { SearchBar } = Search;

type Props = {
  jobs: DocumentType[];
};

const Table = ({ jobs }: Props): JSX.Element => {

  const userInfo = useSelector((state: RootState) => state.userInfo.userInfo) as UserInfoType;

  const permissions = userInfo?.permissions;
  
  const columns = [
    {
      dataField: 'id',
      text: 'S.N',
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: 'name',
      text: 'Name',
      headerAlign: 'center',
      align: 'center',
      sort: true,
    },
    {
      dataField: 'rssUrl',
      text: 'Rss Url',
      headerAlign: 'center',
      align: 'center',
      sort: true,
      formatter: (_cell: any, row: any) => (
        <div>
          <a href={_cell} target="_blank" rel="noreferrer">
            {_cell}
          </a>
        </div>
      ),
    },
    {
      dataField: 'customerId',
      text: 'Customer',
      headerAlign: 'center',
      align: 'center',
      sort: true,
    },
    {
      dataField: 'schedule',
      text: 'Schedule',
      headerAlign: 'center',
      align: 'center',
      formatter: (_cell: any, row: any) => <div> {cronstrue.toString(_cell)}</div>,
    },
    /*{
      dataField: 'edit',
      text: '',
      isDummyField: true,
      csvExport: false,
      formatter: (_cell: any, row: any) =>
          <Link to={`/job/${row.id}`}>Edit</Link>,
      headerAlign: 'center',
      align: 'center',
      headerStyle: (colum, colIndex) => {
        return { width: '100px', textAlign: 'center' };
      }
    },*/
    {
      dataField: 'delete',
      hidden: permissions?.includes('jobs.delete') || userInfo?.isAdmin ? false : true,
      text: '',
      isDummyField: true,
      csvExport: false,
      formatter: (_cell: any, row: any) => (
        <div
          style={{ cursor: 'pointer', color: 'red' }}
          onClick={() => {
            if (window.confirm('Delete a job?')) {
              deleteJob(row.id).then((res) => {
                fetchJobs(dispatch);
              });
            }
          }}
        >
          Delete
        </div>
      ),
      headerAlign: 'center',
      align: 'center',
      headerStyle: (colum, colIndex) => {
        return { width: '100px', textAlign: 'center' };
      },
    },
  ];
  const data = jobs && jobs.length ? jobs : [];
  const dispatch = useAppDispatch();
  const tablePageSize = useAppSelector((state) => state.jobs.tablePageSize);
  const currentPage = useAppSelector((state) => state.jobs.currentPage);
  const pagination = paginationFactory({
    sizePerPage: parseInt(localStorage.getItem('jobs-table-size') || '', 10) || tablePageSize,
    page: currentPage,
    onPageChange: (page) => {
      dispatch(setCurrentPage(page));
    },
    onSizePerPageChange: (sizePage) => {
      sizePerPageDocumentsChange(sizePage);
      dispatch(setTablePageSize(sizePage));
    },
  });

  const sizePerPageDocumentsChange = (sizePerPage: number) => {
    localStorage.setItem('jobs-table-size', sizePerPage.toString());
  };

  return (
    <div style={{ marginBottom: '15px' }}>
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        striped
        hover
        condensed
        //sort={{ dataField: 'created', order: 'desc' }}
        search
      >
        {(props: {
          searchProps: JSX.IntrinsicAttributes;
          baseProps: JSX.IntrinsicAttributes &
            JSX.IntrinsicClassAttributes<BootstrapTable<any, number>> &
            Readonly<BootstrapTableProps<any, number>> &
            Readonly<{ children?: ReactNode }>;
        }) => (
          <div>
            {<SearchBar {...props.searchProps} />}
            <hr />
            <BootstrapTable {...props.baseProps} pagination={pagination} />
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default Table;
